import hero from "/assets/images/hero.jpeg";
export const heroImg = hero;

import hmv from "/assets/videos/hero.mp4";
import smallmv from "/assets/videos/smallHero.mp4";
import highlightFirstmv from "/assets/videos/highlight-first.mp4";
import highlightSecondmv from "/assets/videos/highlight-sec.mp4"; // Corrected name
import highlightThirdmv from "/assets/videos/highlight-third.mp4"; // Corrected name
import highlightFourthmv from "/assets/videos/highlight-fourth.mp4";
import highlightFifthmv from "/assets/videos/highlight-fifth.mp4"; // Added for the fifth highlight
import highlightSixthmv from "/assets/videos/highlight-sixth.mp4"; // Added for the sixth highlight
import exploremv from "/assets/videos/explore.mp4";
import framemv from "/assets/videos/frame.mp4";

import apple from "/assets/images/apple.svg";
import search from "/assets/images/search.svg";
import bag from "/assets/images/bag.svg";
import watch from "/assets/images/watch.svg";
import right from "/assets/images/right.svg";
import replay from "/assets/images/replay.svg";
import play from "/assets/images/play.svg";
import pause from "/assets/images/pause.svg";

import yellow from "/assets/images/yellow.jpg";
// import blue from "/assets/images/blue.jpg";
// import white from "/assets/images/white.jpg";
// import black from "/assets/images/black.jpg";
import explore1 from "/assets/images/explore1.jpg";
import explore2 from "/assets/images/explore2.jpg";
import chip from "/assets/images/chip.png";
import frame from "/assets/images/frame.png";

import ic1 from "../../public/assets/images/IC1.jpg";
import ic2 from "../../public/assets/images/IC2.jpg";
import ic3 from "../../public/assets/images/IC3.jpg";
import ic4 from "../../public/assets/images/IC4.jpg";

export const heroVideo = hmv;
export const smallHeroVideo = smallmv;
export const highlightFirstVideo = highlightFirstmv;
export const highlightSecondVideo = highlightSecondmv; // Corrected name
export const highlightThirdVideo = highlightThirdmv; // Corrected name
export const highlightFourthVideo = highlightFourthmv;
export const highlightFifthVideo = highlightFifthmv; // Added for the fifth highlight
export const highlightSixthVideo = highlightSixthmv; // Added for the sixth highlight
export const exploreVideo = exploremv;
export const frameVideo = framemv;

export const appleImg = apple;
export const searchImg = search;
export const bagImg = bag;
export const watchImg = watch;
export const rightImg = right;
export const replayImg = replay;
export const playImg = play;
export const pauseImg = pause;

export const yellowImg = yellow;
// export const blueImg = blue;
// export const whiteImg = white;
// export const blackImg = black;
export const explore1Img = explore1;
export const explore2Img = explore2;
export const chipImg = chip;
export const frameImg = frame;

export const ic1Img = ic1;
export const ic2Img = ic2;
export const ic3Img = ic3;
export const ic4Img = ic4;

import iPhoneImage from "/assets/images/new.png";
export const iPhone16Image = iPhoneImage;

import img11 from "/assets/images/iphoneImg1.png";
import img12 from "/assets/images/img2card1.png";
import img13 from "/assets/images/img3card1.jpg";

import img21 from "/assets/images/iphoneImg2.png";
import img22 from "/assets/images/img2card2.jpg";
import img23 from "/assets/images/img3card2.jpg";

import img31 from "/assets/images/iphoneImg3.png";
import img32 from "/assets/images/img2card3.jpg";
import img33 from "/assets/images/img3card3.jpg";

export const card1Img1 = img11;
export const card2Img1 = img21;
export const card3Img1 = img31;
export const img2card1 = img12;
export const img2card2 = img22;
export const img2card3 = img32;
export const img3card1 = img13;
export const img3card2 = img23;
export const img3card3 = img33;
